<mat-card *ngIf="!updateMode">{{'addMandoob' | translate}}</mat-card>
<mat-card *ngIf="updateMode">{{'updateMandoob' | translate}}</mat-card>

<div align="end" class="row" style="padding:10px 10px 0 0;">
  <!-- <span class="spacer"></span> -->

  <button mat-raised-button color="primary" (click)="submit()" [disabled]="arabName.invalid">
    <mat-icon>done</mat-icon>
    {{'submit' | translate}}</button>
  &nbsp;
  <button mat-raised-button (click)="back()">
    <mat-icon>keyboard_backspace</mat-icon>
    {{'back' | translate}}</button>
  &nbsp;
</div>


<mat-grid-list cols="3" rowHeight="100px">
  <mat-grid-tile></mat-grid-tile>
  <mat-grid-tile>
    <mat-form-field appearance="standard">
      <mat-label>{{'mandoobName' | translate}}</mat-label>
      <input matInput [(ngModel)]="mandoob.fullName" required #arabName="ngModel">
      <mat-error *ngIf="arabName.invalid">{{'requiredField' | translate}}</mat-error>
    </mat-form-field>

  </mat-grid-tile>


</mat-grid-list>


<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>